// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-intro {
  height: auto;
  text-align: left;
  font-family: "Ubuntu";
  color: black;
  background-color: #e1e1e1;
}

@media only screen and (max-width: 992px){
  .App-intro, #skills, .intro {
    text-align: center;
  }
  .profile-picture {
    margin-bottom: 20px;
    height: 200px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

@media only screen and (max-width: 767px){
  .article, .post {
    text-align: center;
  }
  .main-hr {
    margin-top: 5%;
    margin-bottom: 5%;
  }
}

.App-detail {
  font-family: "Ubuntu";
  color: black;
  background-color: #f4f4f4;
}
`, "",{"version":3,"sources":["webpack://./src/components/App/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;AAC3B","sourcesContent":[".App-intro {\n  height: auto;\n  text-align: left;\n  font-family: \"Ubuntu\";\n  color: black;\n  background-color: #e1e1e1;\n}\n\n@media only screen and (max-width: 992px){\n  .App-intro, #skills, .intro {\n    text-align: center;\n  }\n  .profile-picture {\n    margin-bottom: 20px;\n    height: 200px;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n@media only screen and (max-width: 767px){\n  .article, .post {\n    text-align: center;\n  }\n  .main-hr {\n    margin-top: 5%;\n    margin-bottom: 5%;\n  }\n}\n\n.App-detail {\n  font-family: \"Ubuntu\";\n  color: black;\n  background-color: #f4f4f4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
